module.exports = __webpack_public_path__ + "static/11b9ed8fbc16e67b0fd162f54975982e8bce7aa84e984d25760c32d2ed6bbd63-065f5a7dc9330d0b4ff5d79f58123287.png";